<p *ngIf="selectedFeatureScope === 'Client'">
    Effective date is today: {{ today | date:'mediumDate' }}
</p>
<p *ngIf="!isFutureDate">
    Effective date is today: {{ effectiveDate | date:'mediumDate' }}
</p>
<p *ngIf="isFutureDate && selectedFeatureScope !== 'Client'" class="future">
    Future effective date:
    <strong>{{ effectiveDate | date:'mediumDate' }}</strong>
</p>
<aside>
    <div *ngIf="selectedConsumer">
        <button
            *ngIf="selectedFeatureScope === 'Viewer' && selectedConsumer && isDateToday && selectedConsumer.tag !== 'MOBILE' &&
            (selectedLocationType?.tag === 'CHAIN' || selectedLocationType?.tag === 'LOCATION') &&
            !consumersUnavailableForItemsReport.includes(selectedConsumer?.tag) &&
            !(selectedConsumer?.tag === 'FOOD_TRUCK' && selectedLocationType?.tag === 'LOCATION') ||
            (selectedConsumer?.tag === 'FOOD_TRUCK' && selectedLocationType?.tag === 'LOCATION'
            && selectedVenue?.id !== selectedVenue?.locationId)"
            matTooltip="Download Items Report"
            (click)="handleDownloadItemsReportButtonClicked()"
            mat-icon-button
            type="button"
            class="cma-next"
            [disabled]="!(selectedConsumer && selectedLocation && selectedEffectiveDate && isDateToday)"
        >
            <img src="assets/img/CFA_Icon_Spreadsheet_White_high-res.png"/>
        </button>
        <button
            *ngIf="selectedFeatureScope === 'Viewer' && selectedConsumer && isDateToday && selectedConsumer.tag !== 'MOBILE' &&
            (selectedLocationType?.tag === 'COUNTRY' || selectedLocationType?.tag === 'LOCATION') &&
            !(selectedConsumer?.tag === 'FOOD_TRUCK' && selectedLocationType?.tag === 'LOCATION') &&
            !(selectedConsumer?.tag === 'MASTER_REWARDS_MENU' && selectedLocationType?.tag === 'LOCATION') &&
            !(selectedConsumer?.tag === 'COMMERCEPOINT' && selectedLocationType?.tag === 'COUNTRY')&&
            consumersAvailableForMenuDownload.includes(selectedConsumer?.tag) ||
            (selectedConsumer?.tag === 'FOOD_TRUCK' && selectedLocationType?.tag === 'LOCATION'
            && selectedVenue?.id !== selectedVenue?.locationId)"
            mat-icon-button
            [matTooltip]="downloadMenuTooltip"
            (click)="handleDownloadMenuButtonClicked()"
            type="button"
            class="cma-next"
            [disabled]="!(selectedConsumer && selectedLocation && selectedEffectiveDate && isDateToday)"
        >
            <img src="assets/img/CFA_Icon_Download_White_high-res.png"/>
        </button>
        <button
            *ngIf="selectedFeatureScope === 'Viewer' && selectedConsumer && isDateToday &&
            (selectedLocationType?.tag === 'CHAIN' || selectedLocationType?.tag === 'LOCATION') &&
            !consumersUnavailableForItemsReport.includes(selectedConsumer?.tag) &&
            selectedConsumer?.tag === 'MOBILE'"
            matTooltip="Download Items Report"
            (click)="openItemsReportDownloadOptions($event)"
            mat-icon-button
            [matMenuTriggerFor]="itemsReportMenu"
            #downloadItemsReportTrigger="matMenuTrigger"
            type="button"
            class="cma-next"
            [disabled]="!(selectedConsumer && selectedLocation && selectedEffectiveDate && isDateToday)"
        >
            <img src="assets/img/CFA_Icon_Spreadsheet_White_high-res.png"/>
        </button>
        <button
            *ngIf="selectedFeatureScope === 'Viewer' && selectedConsumer && isDateToday &&
            (selectedLocationType?.tag === 'COUNTRY' || selectedLocationType?.tag === 'LOCATION') &&
            consumersAvailableForMenuDownload.includes(selectedConsumer?.tag) && selectedConsumer.tag ==='MOBILE'"

            mat-icon-button
            matTooltip="Download Mobile Menu"
            (click)="openMenuDownloadOptions($event)"
            [matMenuTriggerFor]="downloadMenu"
            #downloadMenuTrigger="matMenuTrigger"
            type="button"
            class="cma-next"
            [disabled]="!(selectedConsumer && selectedLocation && selectedEffectiveDate && isDateToday)"
        >
            <img src="assets/img/CFA_Icon_Download_White_high-res.png"/>
        </button>
        <mat-menu class="menu-banner-menu" #downloadMenu="matMenu">
            <ng-template matMenuContent  *ngIf="locationTag$ | async">
                <button *ngFor="let option of menuOptions; let i = index"
                        [attr.data-testid]="'download_mobile_button'"
                        mat-menu-item
                        [matTooltipDisabled]="!menuTooltips[i]"
                        [matTooltip]="menuTooltips[i]"
                        (click)="handleDownloadMenuButtonClicked(i, locationTag$.value)"
                >
                    {{ option }}
                </button>

            </ng-template>
        </mat-menu>
        <mat-menu class="menu-banner-menu" #itemsReportMenu="matMenu">
            <ng-template matMenuContent *ngIf="(selectedLocation | async)?.tag === 'CHAIN'">
                <button *ngFor="let option of chainReportOptions; let i = index"
                        [attr.data-testid]="'download_mobile_items_report_button'"
                        mat-menu-item
                        matTooltip="{{ 'Download ' + option + ' Items Report'}}"
                        (click)="handleDownloadItemsReportButtonClicked(i, locationTag$.value)"
                >
                    {{ option }}
                </button>
            </ng-template>
            <ng-template matMenuContent *ngIf="(selectedLocation | async)?.tag !== 'CHAIN'">
                <button *ngFor="let option of reportOptions; let i = index"
                        [attr.data-testid]="'download_mobile_items_report_button'"
                        mat-menu-item
                        matTooltip="{{ 'Download ' + option + ' Items Report'}}"
                        (click)="handleDownloadItemsReportButtonClicked(i, locationTag$.value)"
                >
                    {{ option }}
                </button>
            </ng-template>
        </mat-menu>
        <button
            *ngIf="selectedFeatureScope === 'Viewer' && isDateToday && (isSuperAdmin || isAdmin) && selectedConsumer"
            matTooltip="Publish Menus"
            (click)="handlePublishButtonClicked()"
            mat-icon-button
            type="button"
            class="cma-next"
            [disabled]="!enablePublishButton ||
            !(selectedConsumer && selectedLocation && selectedEffectiveDate && isDateToday)"
        >
            <img class="icon" src="assets/img/CFA_Icon_Share2_White_high-res.png"/>
        </button>
    </div>

    <button *ngIf=" isSubmenuCacheEnabled"
            class="icon"
            mat-icon-button
            matTooltip="Clear submenu cache"
            (click)="clearSubmenuCache.emit()"
    >
        <mat-icon class="icon">cached</mat-icon>
    </button>
    <button *ngIf="isFutureDate"
            [attr.data-testid]="'view_changes_button'"
            class="icon"
            mat-icon-button
            matTooltip="View changes for selected menu or submenu"
            (click)="viewChangeSets.emit()"
    >
        <mat-icon class="icon">info</mat-icon>
    </button>
    <button *ngIf="isFutureDate  && selectedFeatureScope === 'Global'"
            [attr.data-testid]="'edit_changes_button'"
            class="icon"
            mat-icon-button
            matTooltip="Edit change set for selected date"
            (click)="addOrEditChangeSet.emit()"
            [disabled]="!selectedSubmenu"
    >
        <mat-icon class="icon">date_range</mat-icon>
    </button>
</aside>
